module.exports = __webpack_public_path__ + "img/16_78.21e81cfb.png";